import React from 'react';
import {FieldContainer, FieldContainerProps} from './FieldContainer';
import {Field} from '../types';

type FieldContainerTableCellProps = FieldContainerProps;

export const FieldContainerTableCell: React.FunctionComponent<FieldContainerTableCellProps> = ({
                                                                                                   children,
                                                                                                   ...rest
                                                                                               }): JSX.Element => {

    if (rest.field.visibility === 'hidden') {
        return <></>;
    }

    return (
        <td className={[
            rest.editableHighlight && 'highlight-editable',
            !rest.visible && 'hidden'
        ].filter(Boolean).join(' ')}>
            <FieldContainer
                displayFieldLabels={false}
                {...rest}
            >
                {children}
            </FieldContainer>
        </td>
    );
};